import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import messages from './local/index';

const LANG_MAP: Record<string, string> = {
  UA: 'uk',
  PL: 'pl',
  EN: 'en',
};

const storedLang = localStorage.getItem('helios_lang') ?? 'UA';
const initialLng = LANG_MAP[storedLang] ?? 'uk';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: initialLng,
    fallbackLng: 'uk',
    debug: false,
    resources: messages,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;